import React, { useEffect, useState } from 'react';

const Footer: React.FC = () => {
  const [footerText, setFooterText] = useState('');

  useEffect(() => {
    // Anti-crawling: Generate text with JavaScript (most crawlers don't execute JS)
    // Encoded contact information with company name - decoded on client side
    const encoded = [
      // "MassProfit, Inc "
      '77', '97', '115', '115', '80', '114', '111', '102', '105', '116', '44', '32', 
      '73', '110', '99', '32',
      // "8 The Green STE R, Dover, DE, 19901, USA"
      '56', '32', '84', '104', '101', '32', '71', '114', '101', '101', '110', '32', 
      '83', '84', '69', '32', '82', '44', '32', '68', '111', '118', '101', '114', 
      '44', '32', '68', '69', '44', '32', '49', '57', '57', '48', '49', '44', '32', 
      '85', '83', '65'
    ];
    
    // Decode the contact information
    const decoded = encoded.map(code => String.fromCharCode(parseInt(code))).join('');
    
    // Small delay to further prevent automated parsing
    setTimeout(() => {
      setFooterText(decoded);
    }, 100);
  }, []);

  return (
    <footer className="footer">
      <div className="footer-content">
        <span 
          className="footer-text-protected"
          style={{ 
            userSelect: 'none',
            WebkitUserSelect: 'none',
            MozUserSelect: 'none',
            msUserSelect: 'none',
            pointerEvents: 'none',
            fontFamily: 'inherit'
          }}
          aria-label="Contact information"
        >
          {footerText}
        </span>
      </div>
    </footer>
  );
};

export default Footer;
